// extracted by mini-css-extract-plugin
export default {"closed":"fx9MWnXO2DmyFde33lew"};